
import { Component, Vue } from "vue-property-decorator";
import jobdetail from "@/template/jobs/jobDetail.vue";
@Component
export default class jobDetail extends jobdetail {
  mounted() {}
}
